<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { ConfirmDialogHost } from '@/shared/ui/ConfirmDialog'

import { useShell } from '../model/useShell'
import AppMain from './AppMain.vue'
import Navbar from './Navbar.vue'
import RightMenu from './RightMenu.vue'
import Sidebar from './Sidebar.vue'

const route = useRoute()
const { sidebar, isMobile } = useShell()

const classObj = computed(() => ({
  hideSidebar: !sidebar.opened,
  openSidebar: sidebar.opened,
  withoutAnimation: sidebar.withoutAnimation,
  mobile: isMobile.value
}))
</script>

<template>
  <div class="app-wrapper" :class="classObj">
    <div
      v-if="isMobile && sidebar.opened"
      class="drawer-bg"
      @click="sidebar.close()"
    />
    <Sidebar class="sidebar-container" />
    <div class="main-container" :class="route.name">
      <Navbar>
        <template #right-menu>
          <RightMenu />
        </template>
      </Navbar>
      <AppMain />
    </div>
    <ConfirmDialogHost />
  </div>
</template>

<style lang="scss" scoped>
.app-wrapper {
  @include mixins.clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.main-container {
  min-height: 100%;
  margin-bottom: 30px;
  transition: margin-left 0.28s;
  margin-left: var(--side-bar-width);
  position: relative;
}

.sidebar-container {
  transition: width 0.28s;
  width: var(--side-bar-width);
  height: 100%;
  position: fixed;
  font-size: 0;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  overflow: hidden;
}

.hideSidebar {
  .main-container {
    margin-left: 54px;
  }

  .sidebar-container {
    width: 54px;
  }
}

.mobile {
  .main-container {
    margin-left: 0;
  }

  .sidebar-container {
    transition: transform 0.28s;
    width: var(--side-bar-width);
  }

  &.openSidebar {
    position: fixed;
    top: 0;
  }

  &.hideSidebar .sidebar-container {
    pointer-events: none;
    transition-duration: 0.3s;
    transform: translate3d(calc(-1 * var(--side-bar-width)), 0, 0);
  }
}

.withoutAnimation {
  .main-container,
  .sidebar-container {
    transition: none;
  }
}
</style>
